module.exports = __webpack_public_path__ + "media/images/games/fifa-21/hiw-3-133bc849de3d2a9e9e2c23cca59b4f73.jpg";